import { SuperButton } from "../../../../src/components/layout/buttons";
import * as React from 'react';
export default {
  SuperButton,
  React
};